import { Component, EventEmitter, Inject, Input, OnInit, Optional, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DwButtonCommand, DwButtonConfig, DwComponent, DwComponentType, DwExpressionService, DwGridActionKeys, DwGridEvent, DwGridEvents, DwGridHeightMode, DwMdFormContextInfo, DwMessage, DwMessageSeverity, DwMetaDataFormApi, DwMetaDataFormSectionStateService, DwMetaDataFormStateService, DwMetaDataGridComponent, DwMetaDataGridPreferences, DwMetaDataGridViewPreference, DwMetaDataService, DwMetaDataServiceToken, DwMetadataFormUtilService, DwModalConfig, DwModalHandler, DwModalResult, DwRelationshipInfo, DwSectionReadonlyBaseComponent, DwUIMetaDataConfig, DwUIMetaDataConfigToken, DwUiConfigRegistryService, areEqual, ensureArray } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { debounceTime, mergeMap } from 'rxjs/operators';
import { map } from 'underscore';
import { AppMetaDataLookups, AppMetaDataItemNames, PlanOfActionEntity, PilotExaminerEntity, AcsTestEntity, PlanOfActionSectionEntity, AppMetaData, PlanOfActionSectionTypeAllItems, AcsCodeEntity, ApplicantAcsWrittenResultEntity, CheckRideRequestEntity } from '../../../../meta-data/app-meta-data.service';
import { PlanOfActionRepositoryService } from '../../../plan-of-action/services/plan-of-action-repository.service';
import { AcsCodeStatuses } from '../../../plan-of-action/models/acs-code-items.model';
import { DwMdGridCallbacks } from '@devwareapps/devware-cap/devware-ui-metadata/grid/model/callbacks/dw-md-grid-callbacks.interface';
import { PlanOfActionUtilService } from '../../services/plan-of-action-util.service';
import { DwComponentSectionConfigPreference } from '@devwareapps/devware-cap';
import { FormGroup, ValidationErrors } from '@angular/forms';
import { FlightSchoolApplicantEntity } from '../../../../meta-data/app-meta-data.service';
import { RequiredAcsCodesGridConfig } from './required-acs-codes-grid.config';
import { RequiredAcsCodesGridConfigComponent } from './required-acs-codes-grid-config.component';
import { registerRequiredAcsGridValidator } from './required-acs-codes-grid-validation';


@DwComponent({
  key: 'required-acs-codes-grid',
  name: 'Required Acs Codes Grid',
  componentType: DwComponentType.formSection,
  parentItemName: [AppMetaDataItemNames.PlanOfActionSection, AppMetaDataItemNames.ApplicantAcsWrittenResult],
  isGlobal: false,
  configComponent: RequiredAcsCodesGridConfigComponent
})
@Component({
  selector: 'app-required-acs-codes-grid',
  templateUrl: './required-acs-codes-grid.component.html',
  styleUrls: ['./required-acs-codes-grid.component.scss']
})
export class RequiredAcsCodesGridComponent extends DwSectionReadonlyBaseComponent<DwComponentSectionConfigPreference<RequiredAcsCodesGridConfig>> {
  formApi: DwMetaDataFormApi;
  //planOfAction: PlanOfActionEntity;
  //applicantAcsWrittenResult: ApplicantAcsWrittenResultEntity;
  aosCodesItem = AppMetaDataItemNames.AcsCode;

  filters: any = {};
  acsCodeCount: number;
  codesGridPreferences: Partial<DwMetaDataGridPreferences> = {};
  acsCodeStatuses: AcsCodeStatuses;
  gridCallbacks: DwMdGridCallbacks;
  showLegend: boolean = false;

  @ViewChild('dwGrid') dwGrid: DwMetaDataGridComponent;
  mainEntity: PlanOfActionEntity | CheckRideRequestEntity | FlightSchoolApplicantEntity;
  missedCodeValidationMessage = 'Add at least one missed ACS code when the knowledge test score is below 100%.';
  private unregisterValidation: () => void;
  private validationGroup: FormGroup;

  showGrid: boolean = false;
  parentItemName: string;
  sectionDataPath: DwRelationshipInfo[] = [];
  applicationAcsWrittenResult: ApplicantAcsWrittenResultEntity;

  constructor(
    dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    private dwMetaDataFormSectionStateService: DwMetaDataFormSectionStateService,
    private dwMetaDataFormStateService: DwMetaDataFormStateService,
    private dwMetaDataFormUtilService: DwMetadataFormUtilService,
    private planOfActionRepositoryService: PlanOfActionRepositoryService,
    private planOfActionUtil: PlanOfActionUtilService
  ) {
    super(dwExpressionService, dwMetaDataFormSectionStateService, dwMetaDataFormStateService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);

    this.formApi = this.dwMetaDataFormStateService.state.formApi;
  }

  ngOnInit(): void {
    this.setupReadOnlySubscription();
    this.updateValidation();
    this.setupDataWatch();

    this.gridCallbacks = {
      getRowClass: (row) => this.getRowClass(row.data)
    }


  }

  private getRowClass(acsCode: AcsCodeEntity) {
    if (!acsCode || !this.acsCodeStatuses) {
      return;
    }

    if (this.mainEntity._itemName != AppMetaDataItemNames.PlanOfAction) {
      return;
    }

    const acsStatus = this.acsCodeStatuses.codesById[acsCode.AcsCodeId];

    if (acsStatus) {
      if (acsStatus.missing) {
        return 'dw-red';
      }
      return 'dw-green';
    }

    return;
  }

  setupDataWatch() {
    this.subscriptions.push(this.formApi.getFormDataChanges(100)
      .subscribe(dataChange => {
        if (this.formApi.isDataLoadComplete) {
          this.checkForDataChange();
        }
      }));

    if (this.formApi.isDataLoadComplete) {
      this.checkForDataChange();
    }

    this.subscriptions.push(this.formGroup.valueChanges
      .pipe(debounceTime(100))
      .subscribe(v => {
        this.checkForDataChange();
      }));
  }

  protected visibleChanged(): void {
    this.updateValidation();
  }

  protected sectionConfigChanged(): void {
    this.updateValidation();
  }

  private updateValidation(): void {
    const group = this.formApi?.formGroup;
    const enabled = this.sectionConfig?.config?.requireMissedCodeWhenKnowledgeScoreBelow100 === true;
    if (this.unregisterValidation && (!enabled || this.validationGroup !== group)) {
      this.unregisterValidation();
      this.unregisterValidation = null;
    }
    if (enabled && group && !this.unregisterValidation) {
      this.validationGroup = group;
      this.unregisterValidation = registerRequiredAcsGridValidator(group, this, () => this.getMissedCodeValidationError());
    }
    group?.updateValueAndValidity({ emitEvent: false });
  }

  getMissedCodeValidationError(): ValidationErrors {
    if (!this.sectionConfig?.config?.requireMissedCodeWhenKnowledgeScoreBelow100 ||
      !this.visible || this.parentIsVisible === false || this.isReadOnly() || !this.formApi?.isDataLoadComplete ||
      this.formConfig?.rootItemName !== AppMetaDataItemNames.FlightSchoolApplicant) {
      return null;
    }
    const applicant = this.formApi.getFormData<FlightSchoolApplicantEntity>();
    if (!applicant) {
      return null;
    }
    const scoreControl = this.formApi.formGroup.get('AirmanKnowledgeTestScore');
    const score = scoreControl ? scoreControl.value : applicant.AirmanKnowledgeTestScore;
    // Validation must not create relationships or mutate form data.
    let writtenResult: ApplicantAcsWrittenResultEntity = applicant.ApplicantAcsWrittenResult;
    if (this.sectionDataPath.length) {
      let parent: any = applicant;
      writtenResult = null;
      for (const relationship of this.sectionDataPath) {
        parent = parent?.[relationship.propertyName];
        if (relationship.childItem === AppMetaDataItemNames.ApplicantAcsWrittenResult) {
          writtenResult = parent;
          break;
        }
      }
    }
    if (score == null || score === '' || !isFinite(Number(score)) || Number(score) >= 100 ||
      !writtenResult?.AcsTestId || writtenResult.ApplicantAcsWrittenResultMissedCode?.some(c => !c._isDeleted && !!c.AcsCodeId)) {
      return null;
    }
    return {
      ['invalidCustom_requiredAcsCodes_' + this.componentName]: {
        config: { message: this.missedCodeValidationMessage }
      }
    };
  }

  ngOnDestroy(): void {
    this.unregisterValidation?.();
    super.ngOnDestroy();
  }

  onCodeGridEvent(event: DwGridEvent) {
    if (this.isReadOnly()) {
      return;
    }

    console.log(event);

    if (event.actionPreference?.actionKey == 'gridPassthroughRow') {
      // Should only be a delete

      const ascCodes: AcsCodeEntity[] = ensureArray(event.eventData);

      if (ascCodes.length == 0) {
        return;
      }

      this.removeAcsCodes(ascCodes);
    }

  }

  private removeAcsCodes(ascCodes: AcsCodeEntity[]) {
    for (const ascCode of ascCodes) {
      const index = this.applicationAcsWrittenResult.ApplicantAcsWrittenResultMissedCode.findIndex(c => c.AcsCodeId == ascCode.AcsCodeId);

      if (index != -1) {
        const acsCode = this.applicationAcsWrittenResult.ApplicantAcsWrittenResultMissedCode[index];
        acsCode._isDeleted = true;
        //this.mainEntity.ApplicantAcsWrittenResult.ApplicantAcsWrittenResultMissedCode.splice(index, 1);
      }
    }

    this.formApi.patchContextData(DwMdFormContextInfo.DATA_CONTEXT_NAME, this.mainEntity);
    this.formApi.formGroup.patchValue(this.mainEntity);
    this.formApi.setFormData(this.mainEntity);
    this.formApi.formGroup.markAsDirty();

    this.checkForDataChange(true);
  }

  private checkForDataChange(force: boolean = false) {
    this.parentItemName = this.dwMetaDataFormUtilService.getParentItemName(this.dwMetaDataFormStateService.state.formConfig.section, this.sectionConfig, this.dwMetaDataFormStateService.state.itemSecurity.ItemName);
    this.sectionDataPath = this.dwMetaDataFormUtilService.getSectionDataPath(this.sectionConfig, this.formConfig.section, this.formConfig.queryMetaDataList);

    this.mainEntity = this.formApi.getFormData<PlanOfActionEntity | CheckRideRequestEntity | FlightSchoolApplicantEntity>();

    this.applicationAcsWrittenResult = this.planOfActionUtil.getApplicantAcsWrittenResult(this.mainEntity, this.sectionDataPath);
    this.updateValidation();
    if (!this.applicationAcsWrittenResult) {
      this.showGrid = false;
      this.acsCodeCount = 0;
      return;
    }

    // const mainEntity = this.formApi.getFormData<PlanOfActionEntity | CheckRideRequestEntity>();
    // this.mainEntity = mainEntity;

    this.showLegend = false;

    const isRootPOA = this.mainEntity._itemName == AppMetaDataItemNames.PlanOfAction && this.sectionDataPath.length == 0;

    if (isRootPOA) {
      this.showLegend = true;
    }

    if (!this.applicationAcsWrittenResult.ApplicantAcsWrittenResultMissedCode) {
      this.applicationAcsWrittenResult.ApplicantAcsWrittenResultMissedCode = [];
    }

    if (!this.applicationAcsWrittenResult.AcsTestId) {
      this.showGrid = false;
      return;
    }

    this.showGrid = true;

    //console.log('Required ACS Code Grid - checkForDataChange', mainEntity);
    if (isRootPOA) {
      // The CAP item-name check above identifies a root POA; the entity union
      // itself cannot narrow on _itemName because generated entities use string.
      const newAcsCodeStatus = this.planOfActionRepositoryService.getAcsCodeStatus(this.mainEntity as PlanOfActionEntity);

      if (!areEqual(this.acsCodeStatuses, newAcsCodeStatus)) {
        this.acsCodeStatuses = newAcsCodeStatus;

        this.dwGrid?.gridApi?.refreshDataSource(true);
      }
    }


    if (!force && (!this.applicationAcsWrittenResult)) {
      return;
    }



    this.acsCodeCount = this.applicationAcsWrittenResult.ApplicantAcsWrittenResultMissedCode.filter(c => !c._isDeleted).length;

    const acsCodeIds = this.applicationAcsWrittenResult.ApplicantAcsWrittenResultMissedCode?.filter(c => !c._isDeleted)?.map(c => c.AcsCodeId) || [];

    if (acsCodeIds.length == 0) {
      acsCodeIds.push(-1);
    }

    this.filters = {
      AcsCodeId: {
        In: acsCodeIds
      }
    }

    const title = this.sectionConfig.title || 'Standard';

    console.debug(`Required ACS Codes Grid - checkForDataChange - Section: ${title} WrittenId: ${this.applicationAcsWrittenResult.ApplicantAcsWrittenResultId}`, this.filters);
  }

  sectionReadOnlyChanged(readOnly: boolean): void {
    this.updateValidation();
  }

  isReadOnly(): boolean {
    return this.isSectionReadOnly();
  }

}
